import styled from 'styled-components';
import { ShadowElevation } from '../../../library/constants/styles-config';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 800px;
  margin: 16px auto;
  height: 100%;
  z-index: 11;
`;

export const TabMenuContainer = styled(Container)`
  max-width: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  flex-direction: row;
  padding: 16px;
  position: relative;

  > div {
    top: 71px;
    bottom: calc(100% - 111px);
    position: fixed;
    background-color: #F8F9FA;
    box-shadow: 0px 4px 5px -3px rgba(45, 49, 50, 0.2);
  }
`;
